import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import Button from 'components/Button/Button';
import EmptyTaskManagement from 'components/EmptyTaskManagement/EmptyTaskManagement';
import RespondentsModal from 'components/RespodentsModal/RespodentsModal';
import SendSurveyModal from 'components/SendSurveyModal/SendSurveyModal';
import { BUTTON_VARIANT } from 'constants/interfaces';
import AddUserModal from 'pages/MaterialAssessmentPages/MaterialAssessmentIROIndetificator/components/AddUserModal/AddUserModal';

import TableMAInsight from '../TableMaterialityAssessmentInsight/TableMAInsight';

import type { IMaterialAssessmentSurveyBaseViewProps } from './interfaces/IMaterialityAssessmentSurveyView';

import styles from './scss/MaterialAssessmentSurveyBase.module.scss';

function MaterialAssessmentSurveyBaseView({
  isEmptyList,
  handleNextSurvey,
  handleCancelSurvey,
  handlePrevSurvey,
  questionProps,
  insightProps,
  config,
  mainVcTabs,
  handleOpenSendSurveyModal,
  handleCloseSendSurveyModal,
  openSendSurveyModal,
  handleOpenShareModal,
  openShareModal,
  handleCloseShareModal,
  selectedItems,
  handleSelectItem,
  handleAddEmail,
  openAddEmailModal,
  handleCloseAddEmailModal,
  handleCreateRecipientUsers,
  companyId,
  isViewOnly,
}: IMaterialAssessmentSurveyBaseViewProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <div className={styles.tabs}>
        {mainVcTabs.map((item) => (
          <Button
            key={[item.id, item.name].join('-')}
            title={item.name}
            variant={BUTTON_VARIANT.ghost}
            onClick={() => insightProps?.handleClickVcTab?.(item.id)}
            className={clsx(styles.tab, { [styles.active]: insightProps.activeVcTab === item.id })}
          />
        ))}
      </div>
      <span className={styles.header}>{t('materialityAssessment.titleSurvey')}</span>
      <div className={styles.rootContainer}>
        <div className={styles.titleWrapper}>
          <p>{t(config.titleKey)}</p>
          <Button
            title={t('common.sendSurvey', { name: t(config.titleKey) })}
            onClick={() => handleOpenSendSurveyModal()}
            className={styles.button}
            disabled={isViewOnly}
          />
        </div>
        <div className={styles.contentWrapper}>
          {isEmptyList ? (
            <EmptyTaskManagement title={t(config.emptyTableTranslationKey)} />
          ) : (
            <div className={styles.tableWrapper}>
              <TableMAInsight insightProps={insightProps} disableActions={isViewOnly} />
            </div>
          )}
        </div>
        <div className={styles.buttonWrapper}>
          <Button
            title={t('common.cancel')}
            variant={BUTTON_VARIANT.cancel}
            className={styles.button}
            onClick={handleCancelSurvey}
            disabled={isViewOnly}
          />
          <div className={styles.rightButtons}>
            <Button
              title={t('common.prev')}
              onClick={handlePrevSurvey}
              variant={BUTTON_VARIANT.cancel}
              className={styles.prevButton}
              disabled={isViewOnly}
            />
            <Button
              title={t('common.next')}
              onClick={handleNextSurvey}
              className={styles.button}
              disabled={isViewOnly}
            />
          </div>
        </div>
      </div>
      <SendSurveyModal
        open={openSendSurveyModal}
        handleClose={handleCloseSendSurveyModal}
        title={t('common.sendSurvey', { name: t(config.titleKey) })}
        handleShare={handleOpenShareModal}
        isLoading={questionProps.isLoading}
        disabledConfirm={false}
        items={questionProps.items}
        loadMoreQuestions={questionProps.loadMoreQuestions}
        hasMore={questionProps.hasMore}
        selectedItems={selectedItems}
        handleSelectItem={handleSelectItem}
      />
      <RespondentsModal
        open={openShareModal}
        onClose={handleCloseShareModal}
        onShareSurvey={questionProps?.handleShareSurvey}
        selectedItems={selectedItems}
        title={t('common.respondents')}
        titleSend={t('common.sendSurvey', { name: t(config.titleKey) })}
        handleAddEmail={handleAddEmail}
        companyId={companyId}
        currentVcId={insightProps?.activeVcTab}
        isLoading={false}
        isInfoTable
        showHeaderCheckbox
      />
      <AddUserModal
        open={openAddEmailModal}
        onClose={handleCloseAddEmailModal}
        title={t('materialityAssessment.addEmailButton')}
        companyId={companyId}
        handleCreateRecipientUsers={handleCreateRecipientUsers}
      />
    </div>
  );
}

export default MaterialAssessmentSurveyBaseView;
